var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.input,
          expression: "input"
        }
      ],
      attrs: {
        type: "text",
        placeholder: _vm.placeholder,
        "data-cy": "search"
      },
      domProps: { value: _vm.input },
      on: {
        keyup: function($event) {
          return _vm.searchInput()
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.input = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }